<template>
  <form class="form">
    <FormInput :label="$t('form.label.text')" v-model="form.fields.text" name="text"/>
  </form>
</template>

<script>
import {FormInput} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'EditAlert',
  mixins: [FormValidMixin],
  components: {FormInput},
  data() {
    return {
      form: {
        fields: {
          text: {
            valid: false,
            value: ''
          }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (this.form.fields.text.valid) {
        await this.$alert.update(1, {text: this.form.fields.text.value})

        await this.$router.back()
        this.$popup.report(`${this.$t('popup.theAlert')} ${this.$t('popup.modifiedElement')}`, false)
      }
    }
  },
  mounted() {
    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$alert.data) {
      this.form.fields.text = {valid: true, value: this.$alert.data.text}
    }
  }
}
</script>